'use client'
import { ModalHeader, ModalTitle } from '@repo/ui/components'
import { useState } from 'react'
import { ChangeEmailKycForm } from './change-email-kyc.form'
import { ChangeEmailKycOtp } from './change-email-kyc.otp'
import { useTranslate } from '@repo/shared/hooks'

export const ChangeEmailKycContainer = ({
  hasValue,
}: {
  hasValue: boolean
}) => {
  const { t } = useTranslate()
  const [changeStep, setChangeStep] = useState<'otp' | 'form'>('form')
  const [email, setEmail] = useState<string>('')
  const [otp, setOtp] = useState<number>(0)
  const handleFormSuccess = (emailValue: string, otp: number) => {
    setEmail(emailValue)
    setOtp(otp)
    setChangeStep('otp')
  }

  return (
    <>
      {changeStep === 'otp' && (
        <>
          <ModalHeader>
            <ModalTitle>{t('changeEmailKyc_confirm_title')}</ModalTitle>
          </ModalHeader>
          <ChangeEmailKycOtp
            otp={otp}
            email={email}
            handleBack={() => setChangeStep('form')}
          />
        </>
      )}
      {changeStep === 'form' && (
        <>
          <ModalHeader>
            <ModalTitle>
              {!hasValue
                ? t('changeEmailKyc_title_register')
                : t('changeEmailKyc_title_change')}
            </ModalTitle>
          </ModalHeader>
          <ChangeEmailKycForm email={email} onSuccess={handleFormSuccess} />
        </>
      )}
    </>
  )
}
